import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type {
  FindProductByParamsResponse,
  ProductRequestParams,
} from './product-api';

import type { OrderItemCategory } from '../order-item';

export async function getCategories(): Promise<OrderItemCategory[]> {
  const res = await makeRequest<{ payload: OrderItemCategory[] }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${config.apiHost}/merchant-portal/api/v1/public/categories/get-list`,
    withCredentials: true,
    timeout: 60_000,
  });
  return res.payload;
}

export async function findProductByParams(
  params: ProductRequestParams
): Promise<FindProductByParamsResponse> {
  const res = await makeRequest<{ payload: FindProductByParamsResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${config.apiHost}/merchant-portal/api/v2/public/products/get-by-parameters`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}
